function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-724.000000, -628.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(617.000000, 549.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 65.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(107.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.18499994,5 C3.21651821,5 0,8.21659549 0,12.1849999 C0,16.1534044 7.18499994,24.0309372 7.18499994,24.0309372 C7.18499994,24.0309372 14.3699999,16.1530953 14.3699999,12.1849999 C14.3699999,8.21690462 11.1534044,5 7.18499994,5 Z M7.18499994,15.8756493 C5.14727924,15.8756493 3.49593487,14.2243436 3.49593487,12.1865842 C3.49593487,10.1488635 5.1472406,8.49751917 7.18499994,8.49751917 C9.22275928,8.49751917 10.875572,10.1503319 10.875572,12.1865842 C10.875572,14.2227979 9.22275928,15.8756493 7.18499994,15.8756493 Z"
})))))));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "19px",
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.29f001fa.svg";
export { ForwardRef as ReactComponent };